import React from 'react'

export const Spacer = () => {
    return (
        <tr style={{ height: 30 }}>
            <td colSpan={999}></td>
        </tr>
    )
}
